jQuery( function( $ ) {
    "use strict"

} );
